var map = {
	"./033-bm.webp": 1258,
	"./033-cn.webp": 1259,
	"./033.webp": 1260,
	"./13-bm.webp": 1261,
	"./13-cn.webp": 1262,
	"./13.webp": 1263,
	"./3-bm.webp": 1264,
	"./3-cn.webp": 1265,
	"./3.webp": 1266,
	"./angpao-bm.webp": 1267,
	"./angpao-cn.webp": 1268,
	"./angpao.webp": 1269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1257;